import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/constants";

const VerifiedBadge = ({ ok }) => (
  <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${ok ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
    {ok ? "Email confermata" : "In attesa di conferma"}
  </span>
);

export const AdminCompanies = () => {
  const [items, setItems] = useState([]);
  const [plans, setPlans] = useState({});
  useEffect(() => {
    api.get("/admin/companies").then((r) => setItems(r.data));
    api.get("/admin/plans").then((r) => setPlans(Object.fromEntries(r.data.map((p) => [p.plan_id, p.name]))));
  }, []);

  return (
    <section data-testid="admin-companies">
      <h2 className="text-2xl font-bold">Aziende registrate <span className="text-[#75867E]">({items.length})</span></h2>
      {!items.length && <p className="mt-4 rounded-2xl border border-dashed border-[#E2E5DC] p-8 text-center text-sm text-[#75867E]" data-testid="admin-companies-empty">Nessuna azienda registrata per ora.</p>}
      <div className="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {items.map((u) => (
          <article key={u.user_id} className="rounded-2xl border border-[#E2E5DC] bg-white p-5" data-testid={`admin-company-${u.user_id}`}>
            <div className="flex items-start justify-between gap-3">
              <h3 className="break-words text-lg font-bold">{u.company.name}</h3>
              <span className="shrink-0 rounded-full bg-[#0F2D5E] px-3 py-1 text-xs font-semibold text-white">{plans[u.company.plan_id] || u.company.plan_id}</span>
            </div>
            <p className="mt-1 text-sm text-[#495850]">P. IVA {u.company.piva} · {u.company.sede.comune} ({u.company.sede.provincia})</p>
            <p className="mt-3 text-sm"><span className="font-semibold">{u.name}</span> · <span className="break-all">{u.email}</span> · {u.phone}</p>
            <p className="mt-1 text-xs text-[#75867E]">{u.company.sdi ? `SDI ${u.company.sdi}` : ""}{u.company.sdi && u.company.pec ? " · " : ""}{u.company.pec ? `PEC ${u.company.pec}` : ""}</p>
            <div className="mt-4 flex flex-wrap items-center gap-2 text-xs text-[#75867E]">
              <VerifiedBadge ok={u.email_verified} /> Registrata il {fmtDate(u.created_at)}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
